const {store} = aofljs;
import mutations from './mutations';

let sdo = {
  namespace: 'wiaLauncher',
  alias: 'wiaLauncher',
  mutations: mutations
};

store.addState(sdo);



// WEBPACK FOOTER //
// ./home/en-US/js/wia-launcher/sdo/index.js